(function () {
    'use strict';

    angular
        .module('oddCampaignModule')
        .controller('oddCampaignQuestionnaireSectionListEditController', Controller);

    Controller.$inject = ['$scope', 'notificationService', 'oddCampaignService'];

    function Controller($scope, notificationService, oddCampaignService) {
        var boxModelClone = angular.copy($scope.boxModel);
        var campaign = $scope.boxContext.campaign;
        var questionnaire = $scope.boxContext.questionnaire;

        $scope.remove = remove;
        $scope.moveTo = moveTo;

        $scope.ctrlCtxt = {};
        $scope.sortableOptions = {
            animation: 0,
            forceFallback: true,
            scroll: true,
            scrollSpeed: 20,
            scrollSensitivity: 30,
            onUpdate: onSortUpdate,
            handle: '.sortable-handle'
        };

        function remove(item) {
            $scope.ctrlCtxt.isLoading = true;

            return oddCampaignService.deleteSection(campaign.ODDBusinessUnitID, campaign.ODDExternalPartyID,
                    campaign.ODDCampaignID, questionnaire.ODDCampaignQuestionnaireID, item.ODDCampaignSectionID).then(function () {

                notificationService.notify('Section has been deleted');

                _.pull($scope.boxModel, item);
            }).finally(function () {
                $scope.ctrlCtxt.isLoading = false;
            });
        }

        function moveTo(item, direction) {
            _.pull($scope.boxModel, item);

            if (direction === 'top') {
                $scope.boxModel.unshift(item);
            } else {
                $scope.boxModel.push(item);
            }

            onSortUpdate();
        }

        function onSortUpdate() {
            $scope.ctrlCtxt.isLoading = true;
            
            return oddCampaignService.orderSections(campaign.ODDBusinessUnitID, campaign.ODDExternalPartyID,
                    campaign.ODDCampaignID, questionnaire.ODDCampaignQuestionnaireID, $scope.boxModel).then(function() {

                notificationService.notify('Sections have been reordered');
                boxModelClone = angular.copy($scope.boxModel);
            }).catch(function() {
                $scope.boxModel = angular.copy(boxModelClone);
            }).finally(function () {
                $scope.ctrlCtxt.isLoading = false;
            });
        }
    }

})();